var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e20097;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-+30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_14",
    "data-name": 14
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.93 116.33 64.18 116.33 64.18 91.58 53.82 91.58 53.82 116.33 29.08 116.33 29.08 126.69 53.82 126.69 53.82 151.43 64.18 151.43 64.18 126.69 88.93 126.69 88.93 116.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,132.92a25.22,25.22,0,0,1-2,10,21,21,0,0,1-8.44,10.18,25.16,25.16,0,0,1-13.79,3.72,24.86,24.86,0,0,1-13.7-3.82,21.94,21.94,0,0,1-8.64-10.38,28.07,28.07,0,0,1-1.89-8.73,1.05,1.05,0,0,1,1.2-1.19h14.29a1.16,1.16,0,0,1,1.29,1.19,14.81,14.81,0,0,0,1.19,4.76,6.3,6.3,0,0,0,2.38,3,7.17,7.17,0,0,0,10-2.73,13.33,13.33,0,0,0,1.39-6.55,16.21,16.21,0,0,0-1.39-7,6.83,6.83,0,0,0-6.35-3.67,5,5,0,0,0-2.43.74,38.25,38.25,0,0,0-3.43,2.23,1.67,1.67,0,0,1-.79.3,1,1,0,0,1-.9-.59l-7-9.93a1.71,1.71,0,0,1-.3-.79,1,1,0,0,1,.49-.9l15.29-11.61a.43.43,0,0,0,.15-.4c0-.13-.15-.2-.35-.2H92.87a1.11,1.11,0,0,1-.84-.35,1.15,1.15,0,0,1-.35-.84V87.76a1.19,1.19,0,0,1,.35-.85,1.14,1.14,0,0,1,.84-.34h43.28a1.16,1.16,0,0,1,1.19,1.19V101a1.89,1.89,0,0,1-.69,1.49l-12,9.43a.4.4,0,0,0-.15.4c0,.13.15.23.35.29q7.93,2.09,11.51,10.13A26.23,26.23,0,0,1,138.34,132.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,150.84q-6.56-6.41-6.56-17.42V109.2q0-10.92,6.56-17.17t18-6.26q11.42,0,18.07,6.31t6.65,17.12v24.22q0,11-6.65,17.42T170,157.25Q158.58,157.25,152,150.84Zm24-10.12a8.88,8.88,0,0,0,2.23-6.41V108.6a8.88,8.88,0,0,0-2.23-6.4,8,8,0,0,0-6-2.33,7.63,7.63,0,0,0-5.85,2.33,9,9,0,0,0-2.19,6.4v25.71a9.11,9.11,0,0,0,2.14,6.41,7.61,7.61,0,0,0,5.9,2.33A8,8,0,0,0,176,140.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc30);
export default __webpack_public_path__ + "static/media/ic-+30.1c34c70dec0f640ad58f965699943d7d.svg";
export { ForwardRef as ReactComponent };